/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
// import api from '../../../services/api';
import React, { useState, useEffect, useCallback } from 'react';
import 'moment/locale/pt';
import { useLocation, useNavigate } from 'react-router-dom';

import InputMask from "react-input-mask";
import FixedContainer from '../../../../components/Container';
import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { removeCpfMask } from '../../../../utils/functions';
import { enqueueSnackbar } from 'notistack';
import { GetFetch, PutFetch } from '../../../../services/apiBase';

const BrancheDetails = props => {

  const location = useLocation();
  const navigate = useNavigate()

  const [cities, setCities] = useState({})
  const [farmHouse, setFarmHouse] = useState(null);
  const [farmHouseEdited, setFarmHouseEdited] = useState(null);
  const [disabled, setDisabled] = useState(true);

  const [birthCities, setBirthCities] = useState({});
    
  const [newCad, setNewCad] = useState({});

  const [birthCity, setBirthCity] = useState({});
  const [city, setCity] = useState({});
  const [birthState, setBirthState] = useState({});
  const [state, setState] = useState({});

  const [document, setDocument] = useState('');
  const [documentType, setDocumentType] = useState('cpf');

  const [errorValidation, setErrorValidation] = useState({});

  const uf = [
    {label:"AC", value:"AC"},
    {label:"AL", value:"AL"},
    {label:"AP", value:"AP"},
    {label:"AM", value:"AM"},
    {label:"BA", value:"BA"},
    {label:"CE", value:"CE"},
    {label:"DF", value:"DF"},
    {label:"ES", value:"ES"},
    {label:"GO", value:"GO"},
    {label:"MA", value:"MA"},
    {label:"MT", value:"MT"},
    {label:"MS", value:"MS"},
    {label:"MG", value:"MG"},
    {label:"PA", value:"PA"},
    {label:"PB", value:"PB"},
    {label:"PR", value:"PR"},
    {label:"PE", value:"PE"},
    {label:"PI", value:"PI"},
    {label:"RJ", value:"RJ"},
    {label:"RN", value:"RN"},
    {label:"RS", value:"RS"},
    {label:"RO", value:"RO"},
    {label:"RR", value:"RR"},
    {label:"SC", value:"SC"},
    {label:"SP", value:"SP"},
    {label:"SE", value:"SE"},
    {label:"TO", value:"TO"}
  ]

  const handleSelectUF = async (e, id) => {
    const response = await GetFetch(`/subscription/listCity?code_uf=${e}`);
    if (id === "birth_city_id") {
      setBirthCities(response.data)
      setBirthState(e)
    } else if (id === "city_id") {
      setCities(response.data)
      setState(e)
    }
  }
  
  const handleOnSelectCity = (e, id) => {
    setNewCad({...newCad, [id]: e })
    if (id === 'birth_city_id') {
      setErrorValidation({...errorValidation, 'birthCity': false})
      setBirthCity(e)
    }
    if (id === 'city_id'){
      setErrorValidation({...errorValidation, 'city': false})
      setCity(e)
    }
  }

  const handleBackHistory = () => {
    return navigate("/branches");
  }

  const handleDocumentTypeChange = (e) => {
    setDocumentType(e.target.value);
    setDocument('');
  };

  const handleEditFarmHouse = () => {
    setDisabled(!disabled)
    setFarmHouseEdited({...farmHouseEdited, birth_city_id: birthCity && birthCity, city_id: city && city})
    handlePreSelectedUF()
  }

  const handleOnEditingFarmHouse = (e) => {
    const key = e.target.id
    const value = e.target.value
    setFarmHouse({...farmHouse,  [key]: value })
    setFarmHouseEdited({...farmHouseEdited,  [key]: value })
  }

  const handlePreSelectedUF = async () => {
    if (!farmHouse?.birth_city.code_uf) return
    const response = await GetFetch(`/subscription/listCity?code_uf=${farmHouse?.birth_city.code_uf}`);
    setCities(response.data)
  }

  const handleSaveFarmHouse = async () => {
    try {
      setDisabled(!disabled)
      setFarmHouse(null)

      farmHouseEdited.birth_city_id = birthCity
      farmHouseEdited.city_id = city
      farmHouseEdited.owner_document = removeCpfMask(document)

      console.log('PAYLOAD: ', farmHouseEdited)

      await PutFetch(`/financial/updateFarmHouse?id=${farmHouse?.id}`, farmHouseEdited);
      enqueueSnackbar('Filial editada com sucesso!', { variant: 'success' });
      
      handleReloadFarmHouse()
    } catch (error) {
      enqueueSnackbar('Erro ao editar filial', { variant: 'error' });
      
      handleReloadFarmHouse()
  }
  }

  const handleReloadFarmHouse = async () => {
    try {
      const response = await GetFetch(`/financial/showFarmHouse?id=${farmHouse?.id}`);
      setFarmHouse(response.data)
  } catch (error) {
    return navigate("/branches");
  }
  }

  useEffect(() => {
    if(!(location.state)){
      return navigate("/branches");
    } else {
      setFarmHouse(location.state.farmHouse)
    }
  }, [props])

  useEffect(() => {
    if (farmHouse !== null && disabled) {
      handleSelectUF(farmHouse?.birth_city?.code_uf, "birth_city_id")
      handleSelectUF(farmHouse?.city?.code_uf, "city_id")

      handleOnSelectCity(farmHouse?.birth_city?.id_city_ibge, "birth_city_id")
      handleOnSelectCity(farmHouse?.city?.id_city_ibge, "city_id")
      const digits = (farmHouse?.owner_document || '').replace(/\D/g, '');
      setDocumentType(digits.length <= 11 ? 'cpf' : 'cnpj');
      setDocument(farmHouse?.owner_document || '');
    } 
  }, [farmHouse])

  return (
    <>
      <FixedContainer>
        <Box sx={{
          width: '100%',
          height: '100%',
          backgroundColor: '#F9FBFD',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          boxShadow: 3,
          borderRadius: '10px',
          padding: 2,
        }}>
          <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 1 }}>
            Filiais/Detalhes
          </Typography>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              gap: 2
            }}
          > 
            <Button variant='contained' color="info" onClick={() => handleBackHistory()}>
              Voltar
            </Button>
            {disabled ? 
              <Button variant='contained' color="warning" onClick={() => handleEditFarmHouse()}>
                Editar
              </Button>
            :
              <>
                <Button variant='contained' color="success" onClick={() => handleSaveFarmHouse()}>
                  Salvar
                </Button>
                <Button variant='contained' color="error" onClick={() => handleEditFarmHouse()}>
                  Cancelar
                </Button>
              </>
            }
          </Box>

          <Typography variant='h6' sx={{ fontWeight: 500, fontSize: '20px', marginTop: '20px', paddingBottom: 1 }}>
            Pessoal
          </Typography>

          <FormControl fullWidth sx={{ gap: 2 }}>
            <Box sx={{display: 'flex', gap: 2}}>
              <FormControl fullWidth>
                <TextField
                  id={`owner`}
                  label="Proprietário"
                  disabled={disabled}
                  value={farmHouse?.owner ? farmHouse?.owner : "Não informado"}
                  onChange={(event) => {
                    handleOnEditingFarmHouse(event);
                  }}
                />
              </FormControl>

              <FormControl fullWidth>
                <TextField
                  id={`owner_nationality`}
                  label="Nacionalidade"
                  disabled={disabled}
                  value={farmHouse?.owner_nationality ? farmHouse?.owner_nationality : "Não informado"}
                  onChange={(event) => {
                    handleOnEditingFarmHouse(event);
                  }}
                />
              </FormControl>
            </Box>

            <Box sx={{ display: 'flex', gap: 2 }}>
              <FormControl disabled={disabled} fullWidth>
                <InputLabel id="birth_state">Estado</InputLabel>
                <Select
                  labelId="birth_state"
                  id="birth_state"
                  name="birth_state" 
                  label="Estado"
                  value={birthState ? birthState : "Não informado"}
                  onChange={e => handleSelectUF(e.target.value, "birth_city_id")}
                >
                  {uf.map(uf => (
                    <MenuItem value={uf.value}>{uf.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl disabled={disabled} fullWidth>
                <InputLabel id="birth_city">Cidade</InputLabel>
                <Select
                  labelId="birth_city"
                  id="birth_city"
                  name="birth_city" 
                  label="Cidade"
                  value={birthCity ? birthCity : "Não informado"}
                  error={errorValidation?.birthCity}
                  onChange={e => handleOnSelectCity(e.target.value, "birth_city_id")}
                >
                  {birthCities && birthCities.length > 0 ? (birthCities.map(city => (
                    <MenuItem value={city.value}>{city.name_city}</MenuItem>
                  )))
                    : <MenuItem value={''}>{'Carregando...'}</MenuItem> }
                </Select>
              </FormControl>
            </Box>

            <Box sx={{display: 'flex', gap: 2}}>
              <FormControl fullWidth>
                <TextField
                  id="address"
                  label="Rua"
                  disabled={disabled}
                  value={farmHouse?.address ? farmHouse?.address : "Não informado"}
                  onChange={(event) => {
                    handleOnEditingFarmHouse(event);
                  }}
                />
              </FormControl>

              <FormControl fullWidth>
                <TextField
                  id="birth_city.name_country"
                  label="País de nascimento"
                  disabled
                  value={farmHouse?.birth_city ? farmHouse?.birth_city.name_country ? farmHouse?.birth_city.name_country : "Não informado" : "Não informado"}
                  onChange={(event) => {
                    handleOnEditingFarmHouse(event);
                  }}
                />
              </FormControl>
            </Box>

            <Box sx={{display: 'flex', gap: 2}}>
              <FormControl sx={{ minWidth: 140 }} disabled={disabled}>
                <InputLabel id="document-type-label">Tipo</InputLabel>
                <Select
                  labelId="document-type-label"
                  id="document-type"
                  value={documentType}
                  label="Tipo"
                  onChange={handleDocumentTypeChange}
                  disabled={disabled}
                >
                  <MenuItem value="cpf">CPF</MenuItem>
                  <MenuItem value="cnpj">CNPJ</MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth>
                {documentType === 'cpf' ? (
                  <InputMask
                    mask="999.999.999-99"
                    maskChar=" "
                    value={document}
                    disabled={disabled}
                    onChange={(event) => setDocument(event.target.value)}
                  >
                    {() =>
                      <TextField
                        error={errorValidation?.cpf}
                        disabled={disabled}
                        label="CPF"
                      />
                    }
                  </InputMask>
                ) : (
                  <InputMask
                    mask="99.999.999/9999-99"
                    maskChar=" "
                    value={document}
                    disabled={disabled}
                    onChange={(event) => setDocument(event.target.value)}
                  >
                    {() =>
                      <TextField
                        error={errorValidation?.cpf}
                        disabled={disabled}
                        label="CNPJ"
                      />
                    }
                  </InputMask>
                )}
              </FormControl>

              <FormControl fullWidth>
                <TextField
                  id="onwer_marital"
                  label="Estado civil"
                  disabled={disabled}
                  value={farmHouse?.onwer_marital ? farmHouse?.onwer_marital : "Não informado"}
                  onChange={(event) => {
                    handleOnEditingFarmHouse(event);
                  }}
                />
              </FormControl>

              <FormControl fullWidth>
                <TextField
                  id="profession"
                  label="Profissão"
                  disabled={disabled}
                  value={farmHouse?.profession ? farmHouse?.profession : "Não informado"}
                  onChange={(event) => {
                    handleOnEditingFarmHouse(event);
                  }}
                />
              </FormControl>
            </Box>

          </FormControl>

          <Typography variant='h6' sx={{ fontWeight: 500, fontSize: '20px', marginTop: '20px', paddingBottom: 1 }}>
            Fazenda
          </Typography>

          <FormControl fullWidth sx={{ gap: 2 }}>
            <Box sx={{display: 'flex', gap: 2}}>
              <FormControl fullWidth>
                <TextField
                  id="name"
                  label="Nome"
                  disabled={disabled}
                  value={farmHouse?.name ? farmHouse?.name : "Não informado"}
                  onChange={(event) => {
                    handleOnEditingFarmHouse(event);
                  }}
                />
              </FormControl>

              <FormControl fullWidth>
                <TextField
                  id="county"
                  label="Comarca"
                  disabled={disabled}
                  value={farmHouse?.county ? farmHouse?.county : "Não informado"}
                  onChange={(event) => {
                    handleOnEditingFarmHouse(event);
                  }}
                />
              </FormControl>

              <FormControl fullWidth>
                <TextField
                  id="register_number"
                  label="Registro do imovel"
                  disabled={disabled}
                  value={farmHouse?.register_number ? farmHouse?.register_number : "Não informado"}
                  onChange={(event) => {
                    handleOnEditingFarmHouse(event);
                  }}
                />
              </FormControl>
            </Box>
            
            <Box sx={{ display: 'flex', gap: 2 }}>
              <FormControl fullWidth>
                <TextField
                  id="register"
                  label="Matrícula"
                  disabled={disabled}
                  value={farmHouse?.register ? farmHouse?.register : "Não informado"}
                  onChange={(event) => {
                    handleOnEditingFarmHouse(event);
                  }}
                />
              </FormControl>

              <FormControl fullWidth>
                <TextField
                  id="catle_farmhouse"
                  label="Capacidade"
                  disabled={disabled}
                  value={farmHouse?.catle_farmhouse ? farmHouse?.catle_farmhouse : "Não informado"}
                  onChange={(event) => {
                    handleOnEditingFarmHouse(event);
                  }}
                />
              </FormControl>

              <FormControl fullWidth>
                <TextField
                  id="priority"
                  label="Prioridade"
                  disabled={disabled}
                  value={farmHouse?.priority ? farmHouse?.priority : "Não informado"}
                  onChange={(event) => {
                    handleOnEditingFarmHouse(event);
                  }}
                />
              </FormControl>
            </Box>
          </FormControl>

          <Typography variant='h6' sx={{ fontWeight: 500, fontSize: '20px', marginTop: '20px', paddingBottom: 1 }}>
            Endereço
          </Typography>

          <FormControl fullWidth sx={{ gap: 2 }}>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <FormControl fullWidth>
                <TextField
                  id="city.name_country"
                  label="País"
                  disabled
                  value={farmHouse?.city ? farmHouse?.city?.name_country ? farmHouse?.city?.name_country : "Não informado" : "Não informado"}
                  onChange={(event) => {
                    handleOnEditingFarmHouse(event);
                  }}
                />
              </FormControl>

              <FormControl disabled={disabled} fullWidth>
                <InputLabel id="city_id">Estado</InputLabel>
                <Select
                  labelId="city_id"
                  id="city_id"
                  name="city_id" 
                  label="Estado"
                  value={state ? state ? state : "Não informado" : "Não informado"}
                  onChange={e => handleSelectUF(e.target.value, "city_id")}
                >
                  {uf.map(uf => (
                    <MenuItem value={uf.value}>{uf.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl disabled={disabled} fullWidth>
                <InputLabel id="city_id">Cidade</InputLabel>
                <Select
                  labelId="city_id"
                  id="city_id"
                  name="city_id" 
                  label="Cidade"
                  value={city}
                  error={errorValidation?.city}
                  onChange={e => handleOnSelectCity(e.target.value, "city_id")}
                >
                  {cities && cities.length > 0 ? (cities.map(city => (
                    <MenuItem value={city.value}>{city.name_city}</MenuItem>
                  )))
                    : <MenuItem value={''}>{'Carregando...'}</MenuItem> }
                </Select>
              </FormControl>
            </Box>
          </FormControl>
        </Box>
      </FixedContainer>
    </>
  );
}

export default BrancheDetails;
